import React from 'react';

const IconExpand = ({ ...props }) => {
  return (
    <svg
      className='icon-expanded'
      xmlns='http://www.w3.org/2000/svg'
      width='19'
      height='19'
      viewBox='0 0 19 19'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M7.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06l2.72-2.72H1a.75.75 0 0 1 0-1.5h9.19L7.47 4.53a.75.75 0 0 1 0-1.06Z'
        fillRule='evenodd'
        fill='white'
      ></path>
      <path
        d='M15 2.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Z'
        fillRule='evenodd'
        fill='white'
      ></path>
    </svg>
  );
};

export default IconExpand;
